
























import { defineComponent, PropType } from '@nuxtjs/composition-api';
import BaseLink from '@shared/components/@atoms/BaseLink/BaseLink.vue';
import UCIcon from '@shared/components/@atoms/UCIcon/UCIcon.vue';

import { FeatureListIconVariants } from '../constants';
import { IUCFeatureListItem, IUCFeatureListSize } from '../types';
import ThirdPartyLogo from './ThirdPartyLogo.vue';

export default defineComponent({
  name: 'FeatureListItem',
  components: {
    UCIcon,
    ThirdPartyLogo,
    BaseLink,
  },
  props: {
    size: {
      type: String as PropType<IUCFeatureListSize>,
      default: 'compact',
    },
    text: {
      type: String,
      required: true,
    },
    icons: {
      type: Array as PropType<IUCFeatureListItem['icons']>,
      default: () => [],
    },
    link: {
      type: String as PropType<string | undefined>,
      default: undefined,
    },
  },
  data() {
    return { PropositionIconVariants: FeatureListIconVariants };
  },
  computed: {
    ariaLabel(): string {
      return this.text || 'Customer proposition';
    },
    isLink(): boolean {
      return !!this.link;
    },
    iconSize(): string {
      return this.size === 'large' ? 'fa-4x' : 'fa-md';
    },
  },
});
